export default __webpack_public_path__ + "static/media/barcode.9e670a8c.png";